import { type WithIdProps, withId } from "@components/HOC/with-id/withId";
import ContractorDetail from "@components/modules/contractors/Detail";
import { MainLayout } from "@components/widgets/Layout";
import { t } from "@lingui/macro";
import { NavigationContractors } from "@src/components/widgets/AppSubNav/navigation-contractors";
import { createFileRoute } from "@tanstack/react-router";

const Page = ({ id }: WithIdProps) => (
  <MainLayout
    title={t`Contractor detail`}
    navigation={<NavigationContractors contractorId={id} />}
    scrollToTopButton
  >
    <ContractorDetail id={id} />
  </MainLayout>
);

const RouteComponent = withId(Page);

export const Route = createFileRoute("/contractors/detail")({
  component: RouteComponent,
});
